import React from "react";
import NextImage from "../../common/NextImage";
import NoDataFound from "../../common/NoDataFound";

const baseURL = process.env.REACT_APP_BASE_URL;

const TeamStatsTable = ({ data, active, setActive }) => {
  const statsData = active === "goals" ? data?.offense : data?.cards;

  return (
    <div className="league_block">
      <div className="leg_main">
        <div className="leg_head">
          <h2>Teams Statistics</h2>
        </div>
        <nav className="inner_tab">
          <ul>
            <li
              className={active === "goals" ? "active" : ""}
              onClick={() => setActive("goals")}
            >
              <span>Goals</span>
            </li>
            <li
              className={active === "cards" ? "active" : ""}
              onClick={() => setActive("cards")}
            >
              <span>Card</span>
            </li>
          </ul>
        </nav>
      </div>
      <div className="global_table striped offense_tbl">
        {statsData?.length ? (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Team</th>
                <th>Matches Played</th>
                {active === "goals" ? (
                  <th>Goals Scored</th>
                ) : (
                  <>
                    <th>
                      <NextImage
                        src={`${baseURL}/public/assets/images/svg/card-yellow.svg`}
                        width={12}
                        height={12}
                        alt="card"
                      />
                    </th>
                    <th>
                      <NextImage
                        src={`${baseURL}/public/assets/images/svg/card-yellowred.svg`}
                        width={12}
                        height={12}
                        alt="card"
                      />
                    </th>
                    <th>
                      <NextImage
                        src={`${baseURL}/public/assets/images/svg/card-red.svg`}
                        width={12}
                        height={12}
                        alt="card"
                      />
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {statsData?.slice(0, 20)?.map((team, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <span className="team_name">{team?.team?.nm}</span>
                  </td>
                  <td>{team?.pl}</td>
                  {active === "goals" ? (
                    <td>{team?.cn}</td>
                  ) : (
                    <>
                      <td>{team?.yc}</td>
                      <td>{team?.syc}</td>
                      <td>{team?.rc}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
};

export default TeamStatsTable;
